import {Component, Input} from '@angular/core';
import {IdNome} from '../../shared/model/id-nome.model';

@Component({
  selector: 'app-canais-usuarios',
  standalone: true,
  imports: [],
  templateUrl: './canais-usuarios.component.html',
  styleUrl: './canais-usuarios.component.css'
})
export class CanaisUsuariosComponent {

  @Input() canais: IdNome[] = [];

}
